module.exports = __webpack_public_path__ + "img/cost_icon.b376bfef.png";